function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.3838 15.2704C14.0406 15.2704 15.3838 13.9273 15.3838 12.2704C15.3838 10.6136 14.0406 9.27045 12.3838 9.27045C10.7269 9.27045 9.38379 10.6136 9.38379 12.2704C9.38379 13.9273 10.7269 15.2704 12.3838 15.2704Z",
  fill: "#4979C0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.3838 3.27045C12.9361 3.27045 13.3838 3.71816 13.3838 4.27045V5.34134C16.4495 5.77985 18.8744 8.20476 19.3129 11.2704H20.3838C20.9361 11.2704 21.3838 11.7182 21.3838 12.2704C21.3838 12.8227 20.9361 13.2704 20.3838 13.2704H19.3129C18.8744 16.3361 16.4495 18.761 13.3838 19.1996V20.2704C13.3838 20.8227 12.9361 21.2704 12.3838 21.2704C11.8315 21.2704 11.3838 20.8227 11.3838 20.2704V19.1996C8.3181 18.761 5.89319 16.3361 5.45468 13.2704H4.38379C3.8315 13.2704 3.38379 12.8227 3.38379 12.2704C3.38379 11.7182 3.8315 11.2704 4.38379 11.2704H5.45468C5.89319 8.20476 8.3181 5.77985 11.3838 5.34134V4.27045C11.3838 3.71816 11.8315 3.27045 12.3838 3.27045ZM7.38379 12.2704C7.38379 9.50902 9.62237 7.27045 12.3838 7.27045C15.1452 7.27045 17.3838 9.50902 17.3838 12.2704C17.3838 15.0319 15.1452 17.2704 12.3838 17.2704C9.62237 17.2704 7.38379 15.0319 7.38379 12.2704Z",
  fill: "#4979C0"
});

var SvgCenter = function SvgCenter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCenter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/center.8c743d66.svg";
export { ForwardRef as ReactComponent };